import React, { useEffect } from 'react';
import BoxPlotChart from './BoxPlotChart';
import LineChart from './LineChart';
import { useWorkingCapitalFiltersContext } from '../Contexts/WorkingCapitalFiltersProvider';
import { ApSimpleDropdown } from '@alixpartners/ui-components';
import { SingleFilterWrapper } from 'SpendController/Components/Components.styles';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import { Breadcrumbs, ChartAndTableContainer } from '../WorkingCapital.styles';

function Dashboard({ setCurrentContent }) {
	const {
		currentBreakDownFilter,
		handleFilterByChange,
		breakDownFilters,
		getDashBoardBoxPlotByBreakDown,
		boxPlotData,
		getDashBoardLineChartByBreakDown,
		lineChartData,
		dateRangeData,
		handleDateRangeChange,
	} = useWorkingCapitalFiltersContext();
	useEffect(
		() => {
			getDashBoardBoxPlotByBreakDown(currentBreakDownFilter.value);
			getDashBoardLineChartByBreakDown(currentBreakDownFilter.value);
		},
		[currentBreakDownFilter, dateRangeData.dateFrom, dateRangeData.dateTo]
	);

	return (
		<>
			<Breadcrumbs>
				<span onClick={() => setCurrentContent(0)}>Category Widgets</span>&nbsp;/&nbsp;<span
				>
					Dashboard
				</span>
			</Breadcrumbs>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					margin: '10px',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-evenly',
						alignItems: 'center',
						margin: '10px',
					}}
				>
					<ApSimpleDropdown
						label={`Filter By`}
						onChange={e => handleFilterByChange(e)}
						options={breakDownFilters}
						selected={breakDownFilters.find(
							e => e.value === currentBreakDownFilter.value
						)}
					/>
					{/* <SingleFilterWrapper>
						<MultiSelect
							name={`${currentBreakDownFilter.label}`}
							label={`${currentBreakDownFilter.label}`}
							options={currentFilterOptions}
							selected={currentFilterValuesSelected}
							onChange={v => {
								setcurrentFilterValuesSelected(v);
							}}
						/>
					</SingleFilterWrapper> */}
					<SingleFilterWrapper />
					{dateRangeData.srcRange &&
						dateRangeData.stateRange && (
							<MonthPicker
								srcRange={dateRangeData.srcRange}
								stateRange={dateRangeData.stateRange}
								onConfirm={handleDateRangeChange}
							/>
						)}
				</div>
			</div>
			<ChartAndTableContainer>
				<BoxPlotChart
					data={boxPlotData}
					breakDownBy={currentBreakDownFilter.value}
				/>
				<LineChart
					data={lineChartData}
					breakDownBy={currentBreakDownFilter.value}
				/>
			</ChartAndTableContainer>
			<br />
			<br />
		</>
	);
}

export default Dashboard;
